import {
  PAYTYPE_ALL,
  PAYTYPE_GET,
  PAYTYPE_DEL,
  PAYTYPE_PUT,
  PAYTYPE_POST,
  PAYTYPE_LOADING,
  PAYTYPE_ERROR,
  PAYTYPE_RESET,
} from '../../actions/types';

const initialState = {
  paytypes: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PAYTYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYTYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYTYPE_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case PAYTYPE_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case PAYTYPE_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case PAYTYPE_RESET:
      return { paytypes: null, isLoading: true, isCompleted: true };
    case PAYTYPE_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case PAYTYPE_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
